export const locale = {
    lang: 'ds',
    data: {
        'HEADERS': {
            'OfferTravelingAmount': 'Tilbud Kørsel Beløb Pr. Min',
            'SelectCreatedOffer': 'Vælg tilbud',
        },
        'FIELDS': {
            'TravelingAmount': 'Kørsel beløb pr. min'
        },
        'BUTTONS': {
            'Save': 'Gem',
            'Back': 'Tilbage',
            'NEWPROJECTOFFER': 'Nyt tilbud',
            'GoToOffer':'Gå til tilbud'
        },
        'MESSAGES': {
            'Failed': 'Operation mislykket, prøv senere',
            'Success': 'Success',
        }
    }
}